import 'core-js/actual/array/from'
import 'element-closest-polyfill';


import Debounce from './_utils/Debounce';
import FixStickyHover from './_utils/FixStickyHover';
import Throttle from './_utils/Throttle';
import LinkToClipboard from './_utils/LinkToClipboard';
import Navigation from './_utils/Navigation';
import Forms from './_utils/Forms';

import BackgroundVideo from './_modules/BackgroundVideo';
import FocusAreasStrategy from './_modules/FocusAreasStrategy';
import HasScrollingText from './_modules/HasScrollingText';
import HeroHome from './_modules/HeroHome';
import InvestmentList from './_modules/InvestmentList';
import Logos from './_modules/Logos';
import Menu from './_modules/Menu';
import ParallaxImage from './_modules/ParallaxImage';
import PlayWhenScrolledTo from './_modules/PlayWhenScrolledTo';
import PressReleases from './_modules/PressReleases';
import Resources from './_modules/Resources';
import ResourcesFocusArea from './_modules/ResourcesFocusArea';
import SingleInvestmentsContent from './_modules/SingleInvestmentsContent';
import SinglePressReleasesContent from './_modules/SinglePressReleasesContent';
import SingleTeamContent from './_modules/SingleTeamContent';
import Tabs from './_modules/Tabs';
import TeamGrid from './_modules/TeamGrid';
import Testimonial from './_modules/Testimonial';
import Timeline from './_modules/Timeline';
import UpdateWhenScrolledPast from './_modules/UpdateWhenScrolledPast';
import LeavingSiteModal from './_modules/LeavingSiteModal';
import NewsletterModal from './_modules/NewsletterModal';
import VideoModal from './_modules/VideoModal';
import VideoInternal from './_modules/VideoInternal';
import ImageWithHotspots from './_modules/ImageWithHotspots';

function init() {


	// Remove old event handler
	document.removeEventListener('DOMContentLoaded', init);


	// Set various browser/environment classes
	document.documentElement.classList.remove('no-js');
	document.documentElement.classList.add('js');
	document.documentElement.setAttribute('data-useragent', navigator.userAgent);


	// Fix sticky hover on mobile
	FixStickyHover();


	// Menu
	const menu = new Menu(
		[
			'.header-content button.js-menu-btn'
		],
		[
			'#menu a',
			'#menu button',
			'#menu input'
		],
		[
			'#header a',
			'#header button',
			'#main a',
			'#main button',
			'#main input',
			'#main select',
			'#main textarea',
			'#footer a',
			'#footer button',
			'#footer input'
		]
	);
	menu.enable();


	// vars
	var elements = null;
	const updateAnimate = [];
	const updateResize = [];
	const updateScroll = [];


	// BackgroundVideo
	elements = Array.prototype.slice.call(document.querySelectorAll('.background-video'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new BackgroundVideo(element);
			updateResize.push(item);
		});
	}
	elements = null;


	// FocusAreasStrategy
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-focus-areas-strategy'), 0);
	if (elements) {
		elements.forEach(function(element){
			new FocusAreasStrategy(element);
		});
	}
	elements = null;


	// HeroHome
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-hero-home'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new HeroHome(element);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;

  	// HeroHome
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-video-and-logos'), 0);
	if (elements) {
		elements.forEach(function(element){
			new VideoInternal(element);
		});
	}
	elements = null;


	// InvestmentList
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-investments'), 0);
	if (elements) {
		elements.forEach(function(element){
			new InvestmentList(element);
		});
	}
	elements = null;


	// ParallaxImage
	elements = Array.prototype.slice.call(document.querySelectorAll('.parallax-image'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new ParallaxImage(element);
			updateAnimate.push(item);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// PlayWhenScrolledTo
	elements = Array.prototype.slice.call(document.querySelectorAll('.play-when-scrolled-to'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new PlayWhenScrolledTo(element);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// PressReleases
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-press-releases'), 0);
	if (elements) {
		elements.forEach(function(element){
			new PressReleases(element);
		});
	}
	elements = null;


	// HasScrollingText
	elements = Array.prototype.slice.call(document.querySelectorAll('.has-scrolling-text'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new HasScrollingText(element);
			updateAnimate.push(item);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// Logos
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-logos'), 0);
	if (elements) {
		elements.forEach(function(element){
			new Logos(element);
		});
	}
	elements = null;


	// Resources
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-resources'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new Resources(element);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// ResourcesFocusArea
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-resources-focus-area'), 0);
	if (elements) {
		elements.forEach(function(element){
			new ResourcesFocusArea(element);
		});
	}
	elements = null;


	// SingleInvestmentsContent
	elements = Array.prototype.slice.call(document.querySelectorAll('.single-investments-content'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new SingleInvestmentsContent(element);
			updateAnimate.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// SinglePressReleasesContent
	elements = Array.prototype.slice.call(document.querySelectorAll('.single-press-releases-content'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new SinglePressReleasesContent(element);
			updateAnimate.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// SingleTeamContent
	elements = Array.prototype.slice.call(document.querySelectorAll('.single-team-content'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new SingleTeamContent(element);
			updateAnimate.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// Tabs
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-image-and-tabs'), 0);
	if (elements) {
		elements.forEach(function(element){
			new Tabs(element);
		});
	}
	elements = null;


	// TeamGrid
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-team-grid'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new TeamGrid(element);
			updateResize.push(item);
		});
	}
	elements = null;


	// Testimonial
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-testimonials'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new Testimonial(element);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// Timeline
	elements = Array.prototype.slice.call(document.querySelectorAll('.timeline'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new Timeline(element);
			updateAnimate.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;


	// UpdateWhenScrolledPast
	elements = Array.prototype.slice.call(document.querySelectorAll('.update-when-scrolled-past'), 0);
	if (elements) {
		elements.forEach(function(element){
			const item = new UpdateWhenScrolledPast(element);
			updateResize.push(item);
			updateScroll.push(item);
		});
	}
	elements = null;

	// UpdateWhenScrolledPast
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-image-with-hotspots'), 0);
	if (elements) {
		elements.forEach(function(element) {
			new ImageWithHotspots(element);
		});
	}
	elements = null;


	// Event Handler: Frame Animation
	function animate() {
		updateAnimate.forEach(function(element){
			element.animate();
		});
		requestAnimationFrame(animate);
	}
	requestAnimationFrame(animate);


	// Event Handler: Window Resize
	function resize() {
		updateResize.forEach(function(element){
			element.resize();
		});
	}
	const resizeDebounce = Debounce(resize, 250);
	window.addEventListener('orientationchange', resizeDebounce, {capture: true, passive: true});
	window.addEventListener('resize', resizeDebounce, {capture: true, passive: true});
	resize();


	// Event Handler: Window Scroll
	const scrollThrottle = Throttle(function() {
		updateScroll.forEach(function(element){
			element.scroll();
		});
	}, 10);
	function scroll() {
		scrollThrottle();
		// NOTE: add anything that needs to immediately respond to a scroll event goes here
	}
	window.addEventListener('scroll', scroll, {capture: true, passive: true});
	scroll();


	let links = Array.prototype.slice.call(document.querySelectorAll('[href="#leaving_site"]'), 0)
	const leavingSiteModal = new LeavingSiteModal(document.querySelector('.leaving-site-modal'), links)

	const newsletterModal = new NewsletterModal(
		document.querySelector('.newsletter-modal'),
		document.querySelector('.footer--newsletter form')
	)

	const linkClipboard = new LinkToClipboard()

	Navigation()
	Forms()

	let videoModal = new VideoModal()

}


// Wait for page's assets to load
if (document.readyState === 'complete') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', init);
}

